import { type ReactNode, useState } from "react";
import { Modal } from "../Modal";
import styles from "./ConfirmDialog.module.css";

export interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  message: ReactNode;
  confirmLabel?: ReactNode;
  cancelLabel?: ReactNode;
  danger?: boolean;
  /** May return a promise; the button shows a spinner and the dialog closes when it resolves. */
  onConfirm: () => void | Promise<void>;
}

export function ConfirmDialog({
  open,
  onClose,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger,
  onConfirm,
}: ConfirmDialogProps) {
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      // A rejected confirm keeps the dialog open so the caller can show an error and the user can retry.
      setBusy(false);
    }
  };
  return (
    <Modal
      open={open}
      onClose={busy ? () => {} : onClose}
      title={title}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      confirmVariant={danger ? "danger" : "primary"}
      confirmLoading={busy}
      onConfirm={() => void confirm().catch(() => {})}
    >
      <div className={styles.message}>{message}</div>
    </Modal>
  );
}
